// E-mail notification sent when a failed VAT-ID check locks an address or Vorgang (VatLockNotificationDto).
export interface VatLockNotification {
  enabled: boolean
  sender?: string
  recipients?: string[]
}

export const EMAIL_PATTERN = /^[^\s@,;<>]+@[^\s@,;<>]+\.[^\s@,;<>]+$/

// Always returns a fresh object, so a shared default is never mutated through it.
export function normalizeLockNotification(n?: Partial<VatLockNotification> | null): VatLockNotification {
  return {
    enabled: !!n?.enabled,
    sender: n?.sender ?? '',
    recipients: Array.isArray(n?.recipients) ? [...n.recipients] : [],
  }
}

export function parseRecipients(text: string): string[] {
  return text
    .split(/[,;\s]+/)
    .map((r) => r.trim())
    .filter((r) => r.length > 0)
}

export function lockNotificationSenderError(n: VatLockNotification): string | undefined {
  const sender = n.sender ?? ''
  if (n.enabled && sender && !EMAIL_PATTERN.test(sender)) {
    return 'Ungültige Absenderadresse.'
  }
  return undefined
}

export function lockNotificationRecipientsError(n: VatLockNotification): string | undefined {
  if (!n.enabled) {
    return undefined
  }
  const recipients = n.recipients ?? []
  if (recipients.length === 0) {
    return 'Mindestens ein Empfänger muss angegeben werden.'
  }
  const invalid = recipients.filter((r) => !EMAIL_PATTERN.test(r))
  if (invalid.length > 0) {
    return `Ungültige Empfängeradresse: ${invalid.join(', ')}`
  }
  return undefined
}

// First validation error of a notification; a disabled notification is always valid.
export function lockNotificationError(n: VatLockNotification): string | undefined {
  return lockNotificationSenderError(n) ?? lockNotificationRecipientsError(n)
}
